import clsx from 'clsx'
import {HeaderUserMenu, Search} from '../../../partials'
import {useAuth} from '../../../../app/modules/auth'
import {useState} from 'react'
import {useLayout} from '_metronic/layout/core'

const itemClass = 'ms-1 ms-md-4'
const userAvatarClass = 'symbol-35px'

const Navbar = () => {
  const {currentUser} = useAuth()
  const [isHovered, setIsHovered] = useState(false)
  const {config} = useLayout()

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  const spanStyles = {
    // backgroundColor: isHovered ? '#4C5162' : '#181C32',
    backgroundColor: isHovered ? '#498ccfff' : '#2870b6',
    color: '#FFFFFF',
    fontSize: '16px',
    transition: 'color 0.3s',
    padding: '10px',
    borderRadius: '5px',
  }

  return (
    <div className='app-navbar flex-shrink-0'>
      <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
        <Search />
      </div>
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <span
            style={spanStyles}
            className='mx-4'
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <i className='fas fa-user me-1' style={{color: '#FFFFFF'}}></i> {currentUser?.username}
          </span>
        </div>
        <HeaderUserMenu />
      </div>
      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none' title='Show header menu'>
          <div className='btn btn-icon' id='kt_app_header_menu_toggle'>
            <span className='fa fa-bars text-white'></span>
          </div>
        </div>
      )}
    </div>
  )
}

export {Navbar}
